import * as React from 'react';
import { reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import { connect } from 'react-redux';

const AgreementPage3 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="clientOnly" currentPage={3} noScroll>
    <b>Privacy Disclosure:</b>
    <br />
    <br />
    We strongly believe that your personal and financial information is personal. We use and share
    that information about you to perform our obligations under the Client Services Agreement and as
    required by law. We are diligent to use only accurate information. If the information we
    provided is incorrect, please let us know as soon as possible, and we will be diligent to update
    that information. Please observe our Privacy Policy at your convenience or call us at
    520-532-1715
    if you have any questions, comments or concerns.
    <br />
    <br />
    <b>Client Representations, Warranties and Indemnification</b>
    <br />
    <br />
    Ascend is dedicated to keeping our Clients informed of any circumstances known to us at the time
    of your enrollment into the program that may have the effect on Ascend’s ability to resolve any
    of your debt.
    <br />
    <br />
    To ensure that Ascend can provide the best services to you, during our debt settlement services,
    we require that you complete the Creditors and Debt Schedule included in Exhibit 1.
    <br />
    <br />
    Client represents and warrants that:
    <ul style={{ listStyleType: 'disc'}}>
      <li>Client has full power and authority to enter into and perform the obligations under this
        Agreement.
      </li>
      <li>The execution, delivery, and performance of this Agreement have been duly authorized by
        all necessary action on its part.
      </li>
      <li>To Client’s knowledge, the existence of and/or entering into this Agreement does not
        infringe upon any third party contractual rights.
      </li>
      <li>Client’s execution, delivery, and performance of this Agreement does not conflict with any
        agreement, instrument, or understanding to which Client is a party or by which Client may be
        bound.
      </li>
      <li>Client has notified Ascend of all known lawsuits regarding accounts listed in the table below.</li>
      <li>The information provided in the Creditors and Debt Schedule is accurate to the best of Client’s knowledge.</li>
      <li>All of the debts provided in the Creditors and Debt Schedule are unsecured.</li>
    </ul>
    <br />
    Client’s acknowledges and understands that enrollment of certain debts into the program, may result in possibly adverse consequences, including but not limited to: adverse reporting to third party credit bureaus; lawsuit(s) being filed against you by your creditor(s); and/or imposition of fees and/or penalties by your creditor(s).
    <br />
    <br />
    <b>BY YOUR EXECUTION OF THIS AGREEMENT, YOU AGREE TO INDEMNIFY AND HOLD HARMLESS ASCEND, ITS OWNERS, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AND REPRESENTATIVES FROM AND AGAINST ANY AND ALL CLAIMS, LOSSES, LIABILITIES, DAMAGES, COSTS, AND EXPENSES, INCLUDING REASONABLE ATTORNEYS' FEES, ARISING OUT OF OR RESULTING FROM THE PERFORMANCE OF THE SERVICES UNDER THIS AGREEMENT.</b>

  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage3 as any);

export default connect(state => ({
  name: formSelector(state, 'name'),
  existingSignature: formSelector(state, 'clientSignature')
}))(form) as any;
